var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M448,115.24a183.87,183.87,0,0,1-52.87,14.21,91.61,91.61,0,0,0,40.38-50.61A181.17,181.17,0,0,1,377.25,101a91.87,91.87,0,0,0-158.88,62.84,105.52,105.52,0,0,0,2.27,21.06A260.94,260.94,0,0,1,31.33,88.8,92.1,92.1,0,0,0,59.76,211.68,92.68,92.68,0,0,1,18.25,200v1.13a91.83,91.83,0,0,0,73.6,90.14,97.12,97.12,0,0,1-24.17,3.12A121.82,121.82,0,0,1,50.34,293a92,92,0,0,0,85.82,63.7,184,184,0,0,1-114,39.26A188,188,0,0,1,0,394.81,260,260,0,0,0,141,436c168.84,0,261.23-139.89,261.23-261.32,0-4,0-8-.27-12A197.72,197.72,0,0,0,448,115.24Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a072ca56.svg";
export { ForwardRef as ReactComponent };